module.exports = __webpack_public_path__ + "img/user.bc841a07.png";